import './use-of-cookies.scss';

export default function UseOfCookies() {
    return (
        <section>
            <h2 id="use-of-cookies" data-testid="use-of-cookies">
                III. COMO UTILIZAMOS OS COOKIES
            </h2>
            <p>
                Cookies são arquivos ou informações que podem ser armazenadas em
                seus dispositivos, quando você visita o App. Geralmente, um
                cookie contém o nome do App que o originou, seu tempo de vida e
                um valor, que é gerado aleatoriamente.
            </p>
            <p>
                A AMBEV utiliza cookies para facilitar o uso e melhor adaptar o
                App aos seus interesses e necessidades, bem como para
                compilarmos informações sobre a utilização de nossos Apps e
                serviços, auxiliando a melhorar suas estruturas e seus
                conteúdos. Os cookies também podem ser utilizados para acelerar
                suas atividades e experiências futuras no App.
            </p>
            <div className="use-of-cookies-table">
                <thead className="use-of-cookies-thead">
                    <tr className="colored-content">
                        <th>Tipos de Cookies</th>
                        <th>O que eles fazem?</th>
                    </tr>
                </thead>
                <tbody className="use-of-cookies-tbody">
                    <tr>
                        <td>Necessários</td>
                        <td>
                            Esses cookies são essenciais para que o App carregue
                            corretamente e permitem que você navegue em nossos
                            Apps e faça uso de todas as funcionalidades.
                        </td>
                    </tr>
                    <tr>
                        <td>Desempenho</td>
                        <td>
                            Esses cookies nos ajudam a entender como os
                            visitantes interagem com o App, fornecendo
                            informações sobre as áreas visitadas, o tempo de
                            visita ao App e quaisquer problemas encontrados,
                            como mensagens de erro.
                        </td>
                    </tr>
                    <tr>
                        <td>Funcionais</td>
                        <td>
                            Esses cookies permitem que o App se lembre de suas
                            escolhas, para proporcionar uma experiência mais
                            personalizada. Também, possibilitam que os Usuários
                            assistam a vídeos e utilizem ferramentas sociais,
                            campos para comentários, fóruns, entre outros.
                        </td>
                    </tr>
                </tbody>
            </div>
            <p>
                Após o Usuário consentir para a utilização de cookies, quando do
                uso do App, a AMBEV armazenará um cookie em seu dispositivo para
                lembrar disso na próxima sessão.
            </p>
            <p>
                A qualquer momento, o Usuário poderá revogar seu consentimento
                quanto aos cookies, pelo que deverá apagar os cookies do App
                utilizando as configurações de seu navegador de preferência.
                Para mais informações sobre como proceder em relação à gestão
                dos cookies nos navegadores:
            </p>
            <li>
                Internet Explorer:{' '}
                <a
                    href="https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies"
                    target="_blank"
                    rel="noreferrer"
                >
                    https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies
                </a>
            </li>
            <li>
                Mozilla Firefox:{' '}
                <a
                    href="https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento"
                    target="_blank"
                    rel="noreferrer"
                >
                    https://support.mozilla.org/pt-BR/kb/desative-cookies-terceiros-impedir-rastreamento
                </a>
            </li>
            <li>
                Google Chrome:{' '}
                <a
                    href="https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR"
                    target="_blank"
                    rel="noreferrer"
                >
                    https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=pt-BR
                </a>
            </li>
            <li>
                Safari:{' '}
                <a
                    href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac"
                    target="_blank"
                    rel="noreferrer"
                >
                    {' '}
                    https://support.apple.com/pt-br/guide/safari/sfri11471/mac
                </a>
            </li>
            <p>
                Por fim, lembramos que, caso o Usuário não aceite alguns cookies
                do App, certos serviços poderão não funcionar de maneira ideal.
            </p>
        </section>
    );
}
